import { defineComponent, computed, ref, onMounted, onBeforeUnmount } from 'vue';
export default defineComponent({
    setup() {
        const backgroundCount = 6;
        const randomizedImageIndex = computed(() => Math.floor(Math.random() * backgroundCount + 1));
        const image = `image-${randomizedImageIndex.value}`;
        const buzzwords = ['sales', 'growth', 'revenue', 'success', 'deals'];
        const currentBuzzwordIndex = ref(0);
        const currentBuzzword = computed(() => buzzwords[currentBuzzwordIndex.value]);
        const buzzwordContainer = ref(null);
        const switchWord = () => {
            currentBuzzwordIndex.value =
                currentBuzzwordIndex.value === buzzwords.length - 1 ? 0 : ++currentBuzzwordIndex.value;
        };
        onMounted(() => {
            buzzwordContainer.value.addEventListener('animationiteration', switchWord, false);
        });
        onBeforeUnmount(() => {
            buzzwordContainer.value.removeEventListener('animationiteration', switchWord, false);
        });
        return { image, buzzwordContainer, currentBuzzword };
    },
});
